import { useMutation } from '@apollo/client'
import { DenyClearanceStatus, DenyClearanceStatusVariables } from '../../types'
import { DENY_CLEARANCE_STATUS } from './operations'

export const useDenyClearanceStatus = () =>
  useMutation<DenyClearanceStatus, DenyClearanceStatusVariables>(DENY_CLEARANCE_STATUS)
